<template>
  <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
    <div style="display: flex;justify-content: space-between;">
      <div style="display: flex;align-content: center;padding-left: 5px;">{{ $t('Insurance.Premium') }}</div>
      <div v-for="(item,index) in dataProvider" :key="index">
        <div style="display: flex;align-content: center;padding-left: 5px;">
          <span style="font-weight: bold;font-size: 13px;text-decoration:none">{{ item.currency + ': ' }}</span>
          <span :style="style">{{ item.amount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurrencyTotalGroup',
  components: {},
  props: {
    type: { type: String, default: 'all' },
    dataProvider: { type: Array, default: () => [], required: false } // 数据源
  },
  data() {
    return {
      resultList: []
    }
  },
  computed: {
    style() {
      return { 'font-style': 'oblique', 'text-decoration': 'none', 'font-size': '12px', color: '#000000' }
    }
  },
  watch: {
    dataProvider(val) {
    }
  },
  methods: {
  }

}
</script>

<style scoped>

</style>
